import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "footerTitle": "Lebanon Aid Monitor",
      "Lebanon Aid Tracker": "Lebanon Aid Monitor",
      "Dashboard": "Dashboard",
      "GEC": "Government Emergency Committee",
      "GECTitle": "GEC",
      "HRC": "High Relief Committee", 
      "HRCTitle": "HRC", 
      "MOPHTitle": "MOPH",
      "MOPH": "Ministry of Public Health",
      "South Council": "South Council",
      "South CouncilTitle": "South Council",
      "Analysis": "Analysis",
      
      // Common terms
      "Total": "Total",
      "Received": "Received",
      "Distributed": "Distributed",
      "Item": "Item",
      "Unit": "Unit",
      "Donor": "Donor",
      "Category": "Category",
      "Type": "Type",
      "Source": "Source",
      "For": "For",
      "Entity": "Entity",
      "Village": "Village",
      "Amount": "Amount",
      "Date": "Date",
      "Status": "Status",
      "Search": "Search",
      "Filter": "Filter",
      "Export": "Export",
      "Print": "Print",
      "Download": "Download",
      "View Details": "View Details",
      "Show More": "Show More",
      "Show Less": "Show Less",
      "Loading": "Loading...",
      "No Data": "No data available",
      "Error": "Error occurred",
      
      // Dashboard specific
      "Aid Distribution Dashboard": "Aid Distribution Dashboard",
      "Total Aid Received": "Total Aid Received",
      "Total Aid Distributed": "Total Aid Distributed",
      "Distribution Rate": "Distribution Rate",
      "Active Donors": "Active Donors",
      "Recent Distributions": "Recent Distributions",
      "Top Categories": "Top Categories",
      "Monthly Trends": "Monthly Trends",
      
      // Table headers
      "Actions": "Actions",
      "Details": "Details",
      "Edit": "Edit",
      "Delete": "Delete",
      "Add New": "Add New",
      "Save": "Save",
      "Cancel": "Cancel",
      "Confirm": "Confirm",
      
      // Footer
      "All rights reserved": "All rights reserved",
      "Powered by": "Powered by",
      
      // Language switcher
      "Language": "Language",
      "Switch to Arabic": "عربي",
      "Switch to English": "English",
      
      // Additional translations
      "units": "units",
      "tons": "tons",
      "Filter Donations": "Filter Donations",
      "Search Entity": "Search Entity",
      "All Categories": "All Categories",
      "All Entities": "All Entities", 
      "All Types": "All Types",
      "All Donors": "All Donors",
      "Total Donations": "Total Donations",
      "Total Weight": "Total Weight",
      "Donors": "Donors",
      "All Donations": "All Donations",
      "No donations match your filters": "No donations match your filters",
      "View Detailed Analysis": "View Detailed Analysis",
      "Subcategory": "Subcategory",
      "Menu": "Menu",
      "Emergency Relief Aid Distribution and Handover Report": "Emergency Relief Aid Distribution and Handover Report",
      "The main governmental body in charge of leading emergency response and coordinating relief efforts among ministries and public agencies.": "The main governmental body in charge of leading emergency response and coordinating relief efforts among ministries and public agencies.",
      "View Detailed Statistics": "View Detailed Statistics",
      "Total Items": "Total Items",
      "Total Received": "Total Received",
      "Total Distributed": "Total Distributed",
      "Unique Donors": "Unique Donors",
      "Filter Aid Items": "Filter Aid Items",
      "Table View": "Table View",
      "Card View": "Card View",
      "Search Items or Donors": "Search Items or Donors",
      "All Items": "All Items",
      "No items match your filters": "No items match your filters",
      "Procurement and Distribution Report": "Procurement and Distribution Report",
      "Amount": "Amount",
      "For": "For",
      "Language Test": "Language Test",
      "Test Translations": "Test Translations",
      "Test Data Localization": "Test Data Localization",
      "Statistical Overview": "Statistical Overview",
      "Overall Performance": "Overall Performance",
      "Agency not found": "Agency not found",
      "Aid Distribution Dashboard": "Aid Distribution Dashboard",
      "dashboard_description_part1": "After Israel's attack on Lebanon in September 2024, the country faced a significant humanitarian crisis. Large amounts of aid came through official channels but without transparency. The",
      "dashboard_description_part2": "started to track official aid, its delivery, and distribution using public data and access-to-information requests.",
      "Gherbal Initiative": "Gherbal Initiative",
      "Entity": "Entity",
      "Quantity": "Quantity",
      "Weight": "Weight",
      "View Source": "View Source",
      "Packages": "Packages",
      "Location": "Location",
      "Medical": "Medical",
      "Humanitarian Aid Analysis: Data Discrepancies and Distribution Issues": "Humanitarian Aid Analysis: Data Discrepancies and Distribution Issues",
      "Overview": "Overview",
      "analysis_overview_text": "This section analyzes critical data inconsistencies and distribution problems in humanitarian aid management during the 2024 Israeli aggression on Lebanon, covering the period from September 2024 to January 2025.",
      "Data Reliability Warning": "Data Reliability Warning",
      "Key Data Discrepancies Identified": "Key Data Discrepancies Identified",
      "Clear Filters": "Clear Filters",
      "Search Entity": "Search Entity",
      "All Categories": "All Categories",
      "All Entities": "All Entities",
      "All Types": "All Types",
      "All Donors": "All Donors",
      "Donor": "Donor",
      "High Relief Commission": "High Relief Commission",
      "Government Emergency Committee": "Government Emergency Committee",
      "South Council": "South Council",
      "hrc_description": "A national body responsible for receiving donations and aid from international, regional, and local actors, and for providing relief to affected populations. It manages the reception of supplies through ports and airports and coordinates with the government's emergency structures to ensure distribution according to official mechanisms.",
      "Sources": "Sources",
      "Filter Procurement Items": "Filter Procurement Items",
      "Medical Donations and Distribution Report": "Medical Donations and Distribution Report",
      "moph_description": "A key public entity responsible for distributing medical aid and medicines, directly linked to healthcare services through public hospitals and primary health centers.",
      "Total Packages": "Total Packages",
      "Medical Types": "Medical Types",
      "Search Items or Sources": "Search Items or Sources",
      "All Sources": "All Sources",
      "Governorates": "Governorates",
      "Filter Medical Donations": "Filter Medical Donations",
      "Search Medical Donations": "Search Medical Donations",
      "Governorate": "Governorate",
      "All Governorates": "All Governorates",
      "No medical donations match your filters": "No medical donations match your filters",
      "Village Aid Distribution Report": "Village Aid Distribution Report",
      "south_description": "A public institution tasked with delivering assistance in South Lebanon, managing dedicated budget allocations, and implementing development and service projects that include aid distribution.",
      "Total Villages": "Total Villages",
      "Item Types": "Item Types",
      "Filter Village Distributions": "Filter Village Distributions",
      "Search Villages": "Search Villages",
      "Village": "Village",
      "All Villages": "All Villages",
      "Item": "Item",
      "All Records": "All Records",
      "No villages match your filters": "No villages match your filters",
      "Distributed Items": "Distributed Items",
      "Quantities": "Quantities",
      "analysis_warning_intro": "The data inconsistencies identified in this analysis indicate systemic problems in aid tracking and distribution. The scale of discrepancies (hundreds of thousands of units) suggests either:",
      "analysis_issue_1": "Significant data collection and recording failures",
      "analysis_issue_2": "Potential misappropriation of resources",
      "analysis_issue_3": "Complete breakdown of inter-agency coordination",
      "analysis_confidence_text": "Confidence Level in Current Data",
      "LOW": "LOW",
      "analysis_confidence_detail": "Multiple verification failures detected across all major aid categories and donor countries",
      "Measurement Unit Inconsistencies": "Measurement Unit Inconsistencies",
      "Problem": "Problem",
      "measurement_problem_text": "Different agencies use different measurement units for the same items",
      "Example": "Example",
      "measurement_example_text": "Emergency Government Committee records dates as 'boxes' while Higher Relief Authority records them as 'cans'",
      "Impact": "Impact",
      "measurement_impact_text": "Makes accurate tracking and verification impossible",
      "Receipt vs. Distribution Mismatches": "Receipt vs. Distribution Mismatches",
      "Case Study": "Case Study",
      "Kuwaiti Aid": "Kuwaiti Aid",
      "Higher Relief Authority Claims": "Higher Relief Authority Claims",
      "kuwait_received_text": "Received: 42.3 tons (42,300 kg = 42,300 units)",
      "Distributed breakdown": "Distributed breakdown",
      "kuwait_blankets_text": "27,405 blankets",
      "kuwait_food_text": "14,880 food rations",
      "kuwait_medical_text": "50,975 medical supplies",
      "kuwait_total_text": "Total distributed: 93,206 units",
      "kuwait_critical_issue": "Critical Issue: Distribution exceeds receipts by over 50,000 units",
      "Turkish Aid Discrepancies": "Turkish Aid Discrepancies",
      "Biscuits Transfer Issue": "Biscuits Transfer Issue",
      "biscuits_hrc_text": "Higher Relief Authority recorded transferring 5,940 pieces to Emergency Committee",
      "biscuits_gec_text": "Emergency Committee recorded receiving only 720 boxes",
      "biscuits_math_text": "Mathematical impossibility: 5,940 ÷ 720 = 8.25 pieces per box (quarter pieces?)",
      "Pasta Distribution": "Pasta Distribution",
      "pasta_hrc_text": "Higher Relief Authority: 10,000 pieces transferred",
      "pasta_gec_text": "Emergency Committee: 240 boxes received",
      "pasta_ratio_text": "Ratio: 10,000 ÷ 240 = 41.67 pieces per box",
      "HRC Transferred": "HRC Transferred",
      "GEC Received": "GEC Received",
      "Ratio": "Ratio",
      "Issue": "Issue",
      "Summary Statistics Dashboard": "Summary Statistics Dashboard",
      "Total Aid Overview": "Total Aid Overview",
      "Total Received by All Agencies": "Total Received by All Agencies",
      "Total Distributed": "Total Distributed",
      "Unaccounted Difference": "Unaccounted Difference",
      "units": "units",
      "Aid by Month (Received)": "Aid by Month (Received)",
      "Month": "Month",
      "Units Received": "Units Received",
      "Top Donor Countries/Entities": "Top Donor Countries/Entities",
      "Units Provided": "Units Provided",
      "Aid Categories Distribution": "Aid Categories Distribution",
      "Category": "Category",
      "Units": "Units",
      "Major Aid Distribution Anomalies by Country": "Major Aid Distribution Anomalies by Country",
      "Country": "Country",
      "Received": "Received",
      "Distributed": "Distributed",
      "Severity": "Severity",
      "Recommendations for System Improvement": "Recommendations for System Improvement",
      "Immediate Actions Needed": "Immediate Actions Needed",
      "Standardize Measurement Units": "Standardize Measurement Units",
      "standardize_units_text": "Implement unified measurement standards across all agencies",
      "Digital Integration": "Digital Integration",
      "digital_integration_text": "Replace PDF reports with searchable database systems",
      "Real-time Tracking": "Real-time Tracking",
      "realtime_tracking_text": "Establish live inventory management systems",
      "Geographic Mapping": "Geographic Mapping",
      "geographic_mapping_text": "Mandatory location recording for all distributions",
      "Long-term Reforms": "Long-term Reforms",
      "Unified Command Structure": "Unified Command Structure",
      "unified_command_text": "Single coordinating body for all humanitarian aid",
      "Transparency Portal": "Transparency Portal",
      "transparency_portal_text": "Public dashboard showing real-time aid flows",
      "Independent Auditing": "Independent Auditing",
      "independent_auditing_text": "Regular third-party verification of aid distribution",
      "Beneficiary Registration": "Beneficiary Registration",
      "beneficiary_registration_text": "Comprehensive system to track aid recipients",
      "Critical Issues Identified": "Critical Issues Identified",
      "Data Quality Problems": "Data Quality Problems",
      "data_quality_problems_text": "Inconsistent measurement units across agencies, missing timestamps, incomplete geographic data, lack of beneficiary identification systems",
      "Transparency Gaps": "Transparency Gaps",
      "transparency_gaps_text": "71% of Higher Relief Authority distributions marked as 'unknown location', insufficient donor verification, missing cross-referencing, PDF-only data formats",
      "Coordination Failures": "Coordination Failures",
      "coordination_failures_text": "Multiple agencies recording same aid differently, no unified tracking system, lack of real-time inventory management, poor inter-agency communication",
      
      // New detailed case translations
      "Major Cases of Aid Distribution Discrepancies": "Major Cases of Aid Distribution Discrepancies",
      "Case 1: Kuwait Aid - Unit Measurement Confusion": "Case 1: Kuwait Aid - Unit Measurement Confusion",
      "Case 2: Turkey - Biscuits and Pasta Mathematics": "Case 2: Turkey - Biscuits and Pasta Mathematics",
      "Case 3: Turkey - Blankets and Mattresses Multiplication": "Case 3: Turkey - Blankets and Mattresses Multiplication",
      "Case 4: UAE - Missing Sugar and Food": "Case 4: UAE - Missing Sugar and Food",
      "Case 5: Egypt - The Vanishing Blankets": "Case 5: Egypt - The Vanishing Blankets",
      "Case 6: Congo - Multiplication Mystery": "Case 6: Congo - Multiplication Mystery",
      "Case 7: Pakistan - The Bulk Disappearance": "Case 7: Pakistan - The Bulk Disappearance",
      "The Problem": "The Problem",
      "Biscuits Discrepancy": "Biscuits Discrepancy",
      "Pasta Discrepancy": "Pasta Discrepancy",
      "Critical Issue": "Critical Issue",
      "Critical Question": "Critical Question",
      "Items Received from UAE": "Items Received from UAE",
      "Distribution Records (by GEC)": "Distribution Records (by GEC)",
      "Missing/Extra": "Missing/Extra",
      "Received from Egypt": "Received from Egypt",
      "Distributed (according to HRC records)": "Distributed (according to HRC records)",
      "Missing Items": "Missing Items",
      "Data": "Data",
      "Received from Pakistan (Total: 125,749 pieces)": "Received from Pakistan (Total: 125,749 pieces)",
      "Distributed (by HRC)": "Distributed (by HRC)",
      "When traced to GEC records": "When traced to GEC records",
      "HRC Received": "HRC Received",
      "GEC Received": "GEC Received",
      "Overall System-Wide Discrepancies": "Overall System-Wide Discrepancies",
      "Aggregate Comparison": "Aggregate Comparison",
      "By Category - Massive Gaps": "By Category - Massive Gaps",
      "Unaccounted": "Unaccounted",
      "Geographic Distribution Problems": "Geographic Distribution Problems",
      "Unknown Location": "Unknown Location",
      "Known Distribution by Governorate": "Known Distribution by Governorate",
      "Governorate": "Governorate",
      "Units Distributed": "Units Distributed",
      "Received from Turkey": "Received from Turkey",
      "Discrepancy": "Discrepancy",
      
      // Additional detailed translations
      "42.3 tons from Kuwait (recorded as 42,300 kg = 42,300 units)": "42.3 tons from Kuwait (recorded as 42,300 kg = 42,300 units)",
      "The 42.3 tons were broken down into:": "The 42.3 tons were broken down into:",
      "27,405 blankets": "27,405 blankets",
      "14,880 food rations": "14,880 food rations", 
      "50,975 medical supplies": "50,975 medical supplies",
      "Total distributed: 93,206 units": "Total distributed: 93,206 units",
      "How can 42,300 units received become 93,206 units distributed? This represents impossible unit conversion.": "How can 42,300 units received become 93,206 units distributed? This represents impossible unit conversion.",
      "HRC (Higher Relief Authority) transferred:": "HRC (Higher Relief Authority) transferred:",
      "5,940 pieces to GEC (Government Emergency Committee)": "5,940 pieces to GEC (Government Emergency Committee)",
      "GEC recorded receiving:": "GEC recorded receiving:",
      "720 boxes": "720 boxes",
      "Calculation:": "Calculation:",
      "5,940 ÷ 720 = 8.25 pieces per box": "5,940 ÷ 720 = 8.25 pieces per box",
      "Problem:": "Problem:",
      "How can a box contain 8.25 (eight and a quarter) pieces of biscuits?": "How can a box contain 8.25 (eight and a quarter) pieces of biscuits?",
      "HRC transferred:": "HRC transferred:",
      "10,000 pieces to GEC": "10,000 pieces to GEC",
      "240 boxes": "240 boxes",
      "10,000 ÷ 240 = 41.67 pieces per box": "10,000 ÷ 240 = 41.67 pieces per box",
      "Mathematically illogical ratio suggests either:": "Mathematically illogical ratio suggests either:",
      "10 boxes disappeared in transit, OR": "10 boxes disappeared in transit, OR",
      "Recording error (should be 250 boxes = 40 pieces/box)": "Recording error (should be 250 boxes = 40 pieces/box)",
      "5,940 pieces": "5,940 pieces",
      "8.25 pieces/box": "8.25 pieces/box",
      "Quarter pieces?": "Quarter pieces?",
      "10,000 pieces": "10,000 pieces",
      "41.67 pieces/box": "41.67 pieces/box",
      "Mathematical impossibility": "Mathematical impossibility",
      "Blankets": "Blankets",
      "Mattresses": "Mattresses",
      "139,000": "139,000",
      "167,000+": "167,000+",
      "+28,000 blankets appeared": "+28,000 blankets appeared",
      "2,000": "2,000",
      "57,000+": "57,000+",
      "+55,000 mattresses appeared": "+55,000 mattresses appeared",
      "Where did the additional 28,000 blankets and 55,000 mattresses come from? Were there unreported donations?": "Where did the additional 28,000 blankets and 55,000 mattresses come from? Were there unreported donations?",
      "17,280 milk cans": "17,280 milk cans",
      "1,759 bags of sugar (98 tons)": "1,759 bags of sugar (98 tons)",
      "805 pieces of peas (6 tons)": "805 pieces of peas (6 tons)",
      "200 pieces of lentils (6 tons)": "200 pieces of lentils (6 tons)",
      "Milk": "Milk",
      "17,280 cans": "17,280 cans",
      "360 boxes (17,280 cans if 48/box)": "360 boxes (17,280 cans if 48/box)",
      "✓ Matches": "✓ Matches",
      "Sugar": "Sugar",
      "1,759 bags (98 tons)": "1,759 bags (98 tons)",
      "92 tons": "92 tons",
      "-6 tons missing": "-6 tons missing",
      "Peas": "Peas",
      "805 pieces (6 tons)": "805 pieces (6 tons)",
      "1,185 kg (1.185 tons)": "1,185 kg (1.185 tons)",
      "-4.8 tons missing": "-4.8 tons missing",
      "Lentils": "Lentils",
      "200 pieces (6 tons)": "200 pieces (6 tons)",
      "454 kg (7.454 tons)": "454 kg (7.454 tons)",
      "+1 ton extra": "+1 ton extra",
      "6 tons of sugar vanished, while 1 ton of lentils appeared from nowhere.": "6 tons of sugar vanished, while 1 ton of lentils appeared from nowhere.",
      
      // Cases 5-7 translations
      "1,864 food rations": "1,864 food rations",
      "4,000 blankets": "4,000 blankets", 
      "26 tents": "26 tents",
      "21,072 kg food materials": "21,072 kg food materials",
      "1,887 food rations": "1,887 food rations",
      "2,075 blankets": "2,075 blankets",
      "24 tents": "24 tents",
      "No food materials recorded": "No food materials recorded",
      "~2,000 blankets missing + 21 tons food materials unaccounted": "~2,000 blankets missing + 21 tons food materials unaccounted",
      "Congo": "Congo",
      "125,749 pieces total": "125,749 pieces total",
      "Only 23,674 pieces distributed": "Only 23,674 pieces distributed",
      "102,075 pieces missing": "102,075 pieces missing",
      "Where did 81% of Pakistani aid disappear?": "Where did 81% of Pakistani aid disappear?",
      "Total Received": "Total Received",
      "Total Distributed by All Agencies": "Total Distributed by All Agencies",
      "2,806,744 units": "2,806,744 units",
      "2,399,061 units": "2,399,061 units",
      "407,683 units unaccounted": "407,683 units unaccounted",
      "Food": "Food",
      "726,306 received": "726,306 received",
      "580,234 distributed": "580,234 distributed",
      "146,072 unaccounted": "146,072 unaccounted",
      "Medical/Pharmaceutical": "Medical/Pharmaceutical",
      "803,180 received": "803,180 received",
      "721,445 distributed": "721,445 distributed",
      "81,735 unaccounted": "81,735 unaccounted",
      "Shelter": "Shelter",
      "564,809 received": "564,809 received",
      "498,123 distributed": "498,123 distributed",
      "66,686 unaccounted": "66,686 unaccounted",
      "71% of distributions": "71% of distributions",
      "Beirut": "Beirut",
      "Mount Lebanon": "Mount Lebanon",
      "South Lebanon": "South Lebanon",
      "Bekaa": "Bekaa",
      "North Lebanon": "North Lebanon",
      "Nabatieh": "Nabatieh",
      "185,432 (highest)": "185,432 (highest)",
      "156,789": "156,789",
      "98,234": "98,234",
      "87,456": "87,456",
      "72,891": "72,891",
      "50 (lowest)": "50 (lowest)",
      "~2,000 blankets (half the shipment)": "~2,000 blankets (half the shipment)",
      "21 tons of food materials (completely unaccounted for)": "21 tons of food materials (completely unaccounted for)",
      "1,050 pieces of used clothing": "1,050 pieces of used clothing",
      "8,000 blankets": "8,000 blankets",
      "12,750 pieces of clothing": "12,750 pieces of clothing",
      "How does 1,050 pieces become 20,750 items?": "How does 1,050 pieces become 20,750 items?",
      "5,950 blankets": "5,950 blankets",
      "4,000 winter clothes": "4,000 winter clothes",
      "7,124 milk bottles": "7,124 milk bottles",
      "1,845 hygiene bags": "1,845 hygiene bags",
      "14,635 relief materials": "14,635 relief materials",
      "50,000 medicine pieces": "50,000 medicine pieces",
      "2,700 canned food boxes": "2,700 canned food boxes",
      "2,000 pieces of clothing": "2,000 pieces of clothing",
      "22,200 ready-to-eat meals": "22,200 ready-to-eat meals",
      "10,295 tents": "10,295 tents",
      "Only 25 blankets": "Only 25 blankets",
      "684 tents": "684 tents",
      "Everything else: UNACCOUNTED FOR": "Everything else: UNACCOUNTED FOR",
      "Rice": "Rice",
      "Not specified": "Not specified",
      "168 bags (10 kg each)": "168 bags (10 kg each)",
      "Unknown origin": "Unknown origin",
      "5,950": "5,950",
      "1,035": "1,035",
      "Where are 4,915?": "Where are 4,915?",
      "Shelter bags": "Shelter bags",
      "Not in HRC list": "Not in HRC list",
      "2,066": "2,066",
      "New item appeared": "New item appeared",
      "Tents": "Tents",
      "10,295": "10,295",
      "775": "775",
      "Missing 9,520 tents": "Missing 9,520 tents",
      "Packaged food": "Packaged food",
      "2,700 boxes": "2,700 boxes",
      "2,250 boxes": "2,250 boxes",
      "Missing 450 boxes": "Missing 450 boxes",
      "Total Received": "Total Received",
      "2,806,744": "2,806,744",
      "units (All Agencies)": "units (All Agencies)",
      "Total Distributed": "Total Distributed",
      "2,366,729": "2,366,729",
      "units": "units",
      "Gap": "Gap",
      "470,015": "470,015",
      "units (16.74%)": "units (16.74%)",
      "Food": "Food",
      "726,306": "726,306",
      "335,922 (46.2%)": "335,922 (46.2%)",
      "390,384 units": "390,384 units",
      "Medicine": "Medicine",
      "803,180": "803,180",
      "709,358": "709,358",
      "93,822 units": "93,822 units",
      "Shelter": "Shelter",
      "564,809": "564,809",
      "564,455": "564,455",
      "354 units": "354 units",
      "Hygiene": "Hygiene",
      "304,766": "304,766",
      "391,769": "391,769",
      "+86,003 (more distributed!)": "+86,003 (more distributed!)",
      "Clothing": "Clothing",
      "22,601": "22,601",
      "52,841": "52,841",
      "+30,240 (more distributed!)": "+30,240 (more distributed!)",
      "1,753,847 units (74% of total) distributed to \"Unknown Location\"": "1,753,847 units (74% of total) distributed to \"Unknown Location\"",
      "281,057": "281,057",
      "226,158": "226,158",
      "54,145": "54,145",
      "Akkar": "Akkar",
      "10,626": "10,626",
      "18,171": "18,171",
      "Baalbek-Hermel": "Baalbek-Hermel",
      "16,875": "16,875",
      
      // Months
      "September 2024": "September 2024",
      "October 2024": "October 2024", 
      "November 2024": "November 2024",
      "December 2024": "December 2024",
      "Undetermined": "Undetermined",
      
      // Countries
      "UAE": "UAE",
      "Saudi Arabia": "Saudi Arabia",
      "Turkey": "Turkey",
      "Direct Purchases": "Direct Purchases",
      "Pakistan": "Pakistan",
      "Kuwait": "Kuwait",
      "Egypt": "Egypt",
      
      // Categories
      "Medical/Pharmaceutical": "Medical/Pharmaceutical",
      "Food": "Food",
      "Shelter": "Shelter",
      "Health/Hygiene": "Health/Hygiene",
      
      // Severity levels
      "Critical": "Critical",
      "High": "High",
      "Medium": "Medium",
      
      // Turkish discrepancy items
      "Biscuits": "Biscuits",
      "Pasta": "Pasta",
      "5,940 pieces": "5,940 pieces",
      "720 boxes": "720 boxes",
      "8.25 pieces/box": "8.25 pieces/box",
      "Quarter pieces?": "Quarter pieces?",
      "10,000 pieces": "10,000 pieces",
      "240 boxes": "240 boxes",
      "41.67 pieces/box": "41.67 pieces/box",
      "Mathematical impossibility": "Mathematical impossibility",
      
      // Discrepancy case data
      "42.3 tons (42,300 units)": "42.3 tons (42,300 units)",
      "93,206 units": "93,206 units",
      "Distribution exceeds receipts by over 50,000 units": "Distribution exceeds receipts by over 50,000 units",
      "139,000 blankets, 2,000 mattresses": "139,000 blankets, 2,000 mattresses",
      "167,000+ blankets, 57,000+ mattresses": "167,000+ blankets, 57,000+ mattresses",
      "Distribution significantly exceeds receipts": "Distribution significantly exceeds receipts",
      "Various items": "Various items",
      "Missing 17,280 milk cans, 6 tons food materials": "Missing 17,280 milk cans, 6 tons food materials",
      "Significant items unaccounted for": "Significant items unaccounted for",
      "1,864 food rations, 4,000 blankets, 21 tons food": "1,864 food rations, 4,000 blankets, 21 tons food",
      "1,887 food rations, 2,075 blankets": "1,887 food rations, 2,075 blankets",
      "~2,000 blankets and 21 tons food missing": "~2,000 blankets and 21 tons food missing",
      
      // AgencyStats translations
      "Total Aid Received": "Total Aid Received",
      "Total Distributed": "Total Distributed", 
      "Distribution Rate": "Distribution Rate",
      "Undistributed": "Undistributed",
      "units": "units",
      "efficiency": "efficiency",
      "Share of Total National Aid": "Share of Total National Aid",
      "of all aid received by Lebanon": "of all aid received by Lebanon",
      "Peak Activity Period": "Peak Activity Period",
      "Highest Receipt Month": "Highest Receipt Month",
      "Primary Function": "Primary Function",
      "Source": "Source",
      "Service Areas": "Service Areas",
      "Aid by Measurement Units": "Aid by Measurement Units",
      "Unit Type": "Unit Type",
      "Quantity": "Quantity",
      "Weight (Tons)": "Weight (Tons)",
      "Top Donor Countries": "Top Donor Countries",
      "Units Received": "Units Received",
      "Units Distributed": "Units Distributed",
      "Distribution Rate": "Distribution Rate",
      "Weight (Tons)": "Weight (Tons)",
      "Primary Focus Areas": "Primary Focus Areas",
      "Aid Categories": "Aid Categories",
      "Focus Area": "Focus Area",
      "Percentage": "Percentage",
      "Geographic Distribution Issues": "Geographic Distribution Issues",
      "Identified Locations": "Identified Locations",
      "Only 29% of distributions have clear geographic data": "Only 29% of distributions have clear geographic data",
      "Village Distribution Network": "Village Distribution Network",
      "International Support Sources": "International Support Sources",
      "Organization": "Organization",
      "Support Type": "Support Type",
      "Monthly Financial Distribution": "Monthly Financial Distribution",
      "Amount (Million USD)": "Amount (Million USD)",
      
      // Unit types
      "Pieces": "Pieces",
      "Kilograms": "Kilograms", 
      "Medicine Boxes (EA)": "Medicine Boxes (EA)",
      "Rations": "Rations",
      "Boxes": "Boxes",
      "Bags": "Bags",
      "Packages": "Packages",
      "Pills": "Pills",
      "Sets": "Sets",
      "Cans": "Cans",
      "Containers": "Containers",
      "Wooden Boards": "Wooden Boards",
      
      // Focus areas and categories
      "Food Aid": "Food Aid",
      "Shelter Materials": "Shelter Materials",
      "Other Categories": "Other Categories",
      "Heavy Winter Clothing": "Heavy Winter Clothing",
      "Blankets": "Blankets",
      "Basic Necessities": "Basic Necessities",
      
      // Beneficiary types
      "Municipalities": "Municipalities",
      "Displaced Families": "Displaced Families",
      "Non-governmental Organizations": "Non-governmental Organizations",
      "Governorates": "Governorates",
      "Religious Institutions": "Religious Institutions",
      "Official Schools": "Official Schools",
      "Security Forces": "Security Forces",
      "Security/Military Institutions": "Security/Military Institutions",
      "Lebanese Red Cross": "Lebanese Red Cross",
      "Packaging/Processing": "Packaging/Processing",
      "Small amounts": "Small amounts",
      "Some units": "Some units",
      "Various": "Various",
      
      // Countries
      "Qatar": "Qatar",
      "Canada": "Canada",
      "China": "China",
      "UK": "UK",
      "Spain": "Spain",
      
      // Village distribution items
      "Villages Served": "Villages Served",
      "Food Rations Distributed": "Food Rations Distributed",
      "Mattresses": "Mattresses",
      "Blankets/Covers": "Blankets/Covers",
      "Pillows": "Pillows",
      "Milk Containers": "Milk Containers",
      "Baby Diapers": "Baby Diapers",
      
      // Months
      "October": "October",
      "November": "November",
      "December": "December",
      
      // MOPH specific
      "from Higher Relief Authority": "from Higher Relief Authority",
      "Medical and pharmaceutical aid distribution": "Medical and pharmaceutical aid distribution",
      "Chronic diseases": "Chronic diseases",
      "Hospital services": "Hospital services",
      "Primary health centers": "Primary health centers",
      "World Health Organization": "World Health Organization",
      "Medical supplies": "Medical supplies",
      "UNICEF": "UNICEF",
      "Child health materials": "Child health materials",
      "UN Population Fund": "UN Population Fund",
      "Reproductive health supplies": "Reproductive health supplies",
      "Pharmaceutical donations": "Pharmaceutical donations",
      "Medical equipment": "Medical equipment",
      "European Union": "European Union",
      "Chronic disease medications": "Chronic disease medications",
      "Diesel Generators": "Diesel Generators",
      "20,000+ liters for hospitals": "20,000+ liters for hospitals",
      "Oxygen Equipment": "Oxygen Equipment",
      "Various quantities": "Various quantities",
      "Surgical Supplies": "Surgical Supplies",
      "Large quantities distributed": "Large quantities distributed",
      "Anesthesia Equipment": "Anesthesia Equipment",
      "Hospital distribution": "Hospital distribution",
      
      // Geographic and coordination
      "Unknown Locations": "Unknown Locations",
      "Primary Function: Direct distribution to governorates and security institutions": "Primary Function: Direct distribution to governorates and security institutions",
      "Focus Area: South Lebanon villages with direct village-to-village delivery": "Focus Area: South Lebanon villages with direct village-to-village delivery",
      "*Data inconsistency": "*Data inconsistency",
      
      // Key Terms & FAQs
      "Key Terms & FAQs": "Key Terms & FAQs",
      "FAQ": "FAQ",
      
      // Gherbal Initiative Branding
      "Powered by Gherbal Initiative": "Powered by Gherbal Initiative",
      "Transparent Aid Tracking & Data Verification": "Transparent Aid Tracking & Data Verification",
      
      // Information Requests
      "Register of Information Requests": "Register of Information Requests",
      "Official Responses from Administration": "Official Responses from Administration",
      "View Documents": "View Documents",
      "faq_subtitle": "Understanding humanitarian aid terminology and answering common questions about data collection and verification processes.",
      "About This Information": "About This Information",
      
      // Chatbot translations
      "chatbot": {
        "title": "Gherbal Assistant",
        "welcome": "Hello! I'm Gherbal Assistant, your AI-enhanced intelligent assistant. I can help you understand the humanitarian aid distribution report for Lebanon during the 2024 Israeli aggression. Ask me about aid amounts, donor countries, distribution issues, or transparency concerns.",
        "placeholder": "Ask me about the aid report...",
        "suggestedQuestions": "Suggested Questions:",
        "questions": {
          "totalAid": "What was the total amount of aid received?",
          "topDonors": "Which countries were the top donors?",
          "aidCategories": "What types of aid were distributed?",
          "distributionIssues": "What problems were found in distribution?",
          "transparency": "What transparency issues were identified?"
        }
      },
      "faq_overview_text": "This page provides definitions of key terms used throughout the Lebanon Aid Tracker and answers frequently asked questions about our data collection, verification, and transparency processes.",
      
      // Key Terms
      "Key Terms and Definitions": "Key Terms and Definitions",
      "key_terms_intro": "Essential terminology used in humanitarian aid tracking and distribution in Lebanon.",
      
      "In-Kind Aid": "In-Kind Aid",
      "in_kind_aid_definition": "Material assistance provided in the form of goods rather than cash. This includes items such as food, medicine, blankets, tents, hygiene kits, and medical supplies.",
      
      "Receiving Entity": "Receiving Entity",
      "receiving_entity_definition": "The official government body or organization that accepts humanitarian aid on behalf of the Lebanese state, such as the Higher Relief Committee, Government Emergency Committee, or South Council.",
      
      "Distributing Entity": "Distributing Entity", 
      "distributing_entity_definition": "The organization or institution responsible for delivering aid to final beneficiaries, including municipalities, NGOs, Lebanese Red Cross, or government ministries.",
      
      "Aid Categories": "Aid Categories",
      "aid_categories_definition": "Medicine: Pharmaceuticals, medical supplies, and health equipment\nFood: Food parcels, ready-to-eat meals, staple goods\nShelter: Tents, blankets, mattresses, heating materials\nHygiene: Sanitation kits, cleaning supplies, personal care items\nMixed Aid: Packages combining multiple categories",
      
      "Unit of Measurement Discrepancy": "Unit of Measurement Discrepancy",
      "unit_discrepancy_definition": "When different entities record the same aid using different units (e.g., one records \"boxes\" while another records \"pieces\"), making accurate tracking difficult.",
      
      "Displaced Persons": "Displaced Persons (النازحون)",
      "displaced_persons_definition": "Individuals forced to leave their homes due to military aggression, seeking temporary shelter in safer areas within Lebanon.",
      
      // FAQs
      "Frequently Asked Questions": "Frequently Asked Questions",
      "faq_intro": "Common questions about our data collection, verification processes, and transparency measures.",
      
      "How does Gherbal verify data?": "How does Gherbal verify data?",
      "data_verification_answer": "Gherbal collects data through multiple sources:\n\n• Official Requests: Formal information requests submitted to government entities under Access to Information Law 28/2017\n• Published Records: Information published on official government websites and platforms\n• Official Media: Statements and figures released through the National News Agency and official channels\n• Cross-Referencing: Comparing data across multiple sources to identify discrepancies\n\nAll documentation, including official responses and correspondence, is preserved and can be provided upon request.",
      
      "Why is some data missing or incomplete?": "Why is some data missing or incomplete?",
      "missing_data_answer": "Several factors contribute to data gaps:\n\n• Non-Response: Some government entities did not respond to information requests despite legal obligations\n• Partial Information: Some entities provided general references to websites rather than detailed datasets\n• Format Issues: Data published in PDF format or without structured fields limits analysis\n• Inconsistent Recording: Different measurement units and classification systems across entities\n• Ongoing Operations: Some aid was marked as \"in storage\" without distribution timelines",
      
      "Why is data missing for region X?": "Why is data missing for region X?",
      "regional_gaps_answer": "Geographic data gaps occur for several reasons:\n\n• Recording Practices: Over 70% of aid distributed by the Higher Relief Committee was recorded as \"location unknown\"\n• Displacement Patterns: Areas experiencing active conflict saw population displacement, reducing local distribution\n• Concentration in Host Areas: Aid concentrated in regions receiving displaced persons (Beirut, Mount Lebanon) rather than conflict zones\n• Incomplete Documentation: Some entities did not specify distribution locations in their records",
      
      "How accurate is this data?": "How accurate is this data?",
      "data_accuracy_answer": "The data reflects what was officially recorded and disclosed by government entities. Gherbal documents:\n\n• What we received: Official responses and published government data\n• Known discrepancies: Identified inconsistencies between entities\n• Data limitations: Missing fields, unclear measurements, and gaps\n\nThis is a documentation effort, not a definitive count. Actual aid volumes may differ from recorded figures.",
      
      "Is this data updated in real-time?": "Is this data updated in real-time?",
      "real_time_updates_answer": "No. This report covers the period from September 2024 through January 2025. Updates depend on:\n\n• New official disclosures\n• Responses to pending information requests\n• Availability of resources for continued monitoring",
      
      "Who can use this data?": "Who can use this data?",
      "data_usage_answer": "This data is publicly available for:\n\n• Researchers and academics\n• Journalists and media organizations\n• Civil society organizations\n• International donors and humanitarian agencies\n• Any citizen seeking transparency in aid distribution\n\nAttribution to Gherbal Initiative is appreciated but not required.",
      
      "Why focus on government-managed aid?": "Why focus on government-managed aid?",
      "government_focus_answer": "The Lebanese state received substantial international aid through official channels. Tracking government-managed aid is essential for:\n\n• Public accountability\n• Assessing distribution equity\n• Evaluating coordination effectiveness\n• Informing future emergency response planning\n\nThis does not diminish the important work of NGOs and international organizations operating independently.",
      
      // Additional Information Section
      "Data Sources and Methodology": "Data Sources and Methodology",
      "Official Sources": "Official Sources",
      "official_sources_text": "All data comes from official government responses to access-to-information requests, published government reports, and verified official statements.",
      
      "Transparency Commitment": "Transparency Commitment",
      "transparency_commitment_text": "We maintain complete documentation of all sources, correspondence, and data collection processes. All materials are available for public review.",
      
      "Contact Information": "Contact Information",
      "contact_information_text": "For questions about methodology, data sources, or to request additional documentation, please visit elgherbal.org or contact us through official channels."
    }
  },
  ar: {
    translation: {
      // Navigation
      "footerTitle": "متتبع المساعدات الإنسانية في لبنان",
      "Lebanon Aid Tracker": "متتبع المساعدات اللبنانية",
      "Dashboard": "الرئيسية",
      "GEC": "لجنة الطوارئ الحكومية",
      "GECTitle": "لجنة الطوارئ الحكومية",
      "HRC": "الهيئة العليا للإغاثة",
      "HRCTitle": "الهيئة العليا للإغاثة",
      "MOPH": "وزارة الصحة",
      "MOPHTitle": "وزارة الصحة",
      "South Council": "مجلس الجنوب",
      "South CouncilTitle": "مجلس الجنوب",
      "Analysis": "التحليل",
      
      // Common terms
      "Total": "المجموع",
      "Received": "المستلم",
      "Distributed": "الموزع",
      "Item": "الصنف",
      "Unit": "الوحدة",
      "Donor": "المانح",
      "Category": "الفئة",
      "Type": "النوع",
      "Source": "المصدر",
      "For": "لـ",
      "Entity": "الجهة",
      "Village": "القرية",
      "Amount": "الكمية",
      "Date": "التاريخ",
      "Status": "الحالة",
      "Search": "بحث",
      "Filter": "تصفية",
      "Export": "تصدير",
      "Print": "طباعة",
      "Download": "تحميل",
      "View Details": "عرض التفاصيل",
      "Show More": "عرض المزيد",
      "Show Less": "عرض أقل",
      "Loading": "جاري التحميل...",
      "No Data": "لا توجد بيانات متاحة",
      "Error": "حدث خطأ",
      
      // Dashboard specific
      "Aid Distribution Dashboard": "لوحة توزيع المساعدات",
      "Total Aid Received": "إجمالي المساعدات المستلمة",
      "Total Aid Distributed": "إجمالي المساعدات الموزعة",
      "Distribution Rate": "معدل التوزيع",
      "Active Donors": "المانحون النشطون",
      "Recent Distributions": "التوزيعات الأخيرة",
      "Top Categories": "الفئات الرئيسية",
      "Monthly Trends": "الاتجاهات الشهرية",
      
      // Table headers
      "Actions": "الإجراءات",
      "Details": "التفاصيل",
      "Edit": "تعديل",
      "Delete": "حذف",
      "Add New": "إضافة جديد",
      "Save": "حفظ",
      "Cancel": "إلغاء",
      "Confirm": "تأكيد",
      
      // Footer
      "All rights reserved": "جميع الحقوق محفوظة",
      "Powered by": "مدعوم من",
      
      // Language switcher
      "Language": "اللغة",
      "Switch to Arabic": "عربي",
      "Switch to English": "English",
      
      // Additional translations
      "units": "وحدات",
      "tons": "أطنان",
      "Filter Donations": "تصفية التبرعات",
      "Search Entity": "البحث في الجهة",
      "All Categories": "جميع الفئات",
      "All Entities": "جميع الجهات",
      "All Types": "جميع الأنواع", 
      "All Donors": "جميع المانحين",
      "Total Donations": "إجمالي التبرعات",
      "Total Weight": "الوزن الإجمالي",
      "Donors": "المانحون",
      "All Donations": "جميع التبرعات",
      "No donations match your filters": "لا توجد تبرعات تطابق المرشحات",
      "View Detailed Analysis": "عرض التحليل المفصل",
      "Subcategory": "الفئة الفرعية",
      "Menu": "القائمة",
      "Emergency Relief Aid Distribution and Handover Report": "تقرير توزيع وتسليم المساعدات الطارئة",
      "The main governmental body in charge of leading emergency response and coordinating relief efforts among ministries and public agencies.": "الهيئة الحكومية الرئيسية المسؤولة عن قيادة الاستجابة للطوارئ وتنسيق جهود الإغاثة بين الوزارات والوكالات العامة.",
      "View Detailed Statistics": "عرض الإحصائيات المفصلة",
      "Total Items": "إجمالي العناصر",
      "Total Received": "إجمالي المستلم",
      "Total Distributed": "إجمالي الموزع",
      "Unique Donors": "المانحون الفريدون",
      "Filter Aid Items": "تصفية عناصر المساعدة",
      "Table View": "عرض الجدول",
      "Card View": "عرض البطاقات",
      "Search Items or Donors": "البحث في العناصر أو المانحين",
      "All Items": "جميع العناصر",
      "No items match your filters": "لا توجد عناصر تطابق المرشحات",
      "Procurement and Distribution Report": "تقرير المشتريات والتوزيع",
      "Amount": "الكمية",
      "For": "لـ",
      "Language Test": "اختبار اللغة",
      "Test Translations": "اختبار الترجمات",
      "Test Data Localization": "اختبار توطين البيانات",
      "Statistical Overview": "نظرة إحصائية عامة",
      "Overall Performance": "الأداء العام",
      "Agency not found": "الوكالة غير موجودة",
      "Aid Distribution Dashboard": "لوحة توزيع المساعدات",
      "dashboard_description_part1": "بعد هجوم إسرائيل على لبنان في سبتمبر 2024، واجه البلد أزمة إنسانية كبيرة. وصلت كميات كبيرة من المساعدات عبر القنوات الرسمية ولكن دون شفافية.",
      "dashboard_description_part2": "بدأت في تتبع المساعدات الرسمية وتسليمها وتوزيعها باستخدام البيانات العامة وطلبات الوصول إلى المعلومات.",
      "Gherbal Initiative": "مبادرة غربال",
      "Entity": "الجهة",
      "Quantity": "الكمية",
      "Weight": "الوزن",
      "View Source": "عرض المصدر",
      "Packages": "الرزم",
      "Location": "الموقع",
      "Medical": "طبي",
      "Humanitarian Aid Analysis: Data Discrepancies and Distribution Issues": "تحليل المساعدات الإنسانية: تضارب البيانات ومشاكل التوزيع",
      "Overview": "نظرة عامة",
      "analysis_overview_text": "يحلل هذا القسم التناقضات الحرجة في البيانات ومشاكل التوزيع في إدارة المساعدات الإنسانية خلال العدوان الإسرائيلي على لبنان عام 2024، والذي يغطي الفترة من سبتمبر 2024 إلى يناير 2025.",
      "Data Reliability Warning": "تحذير موثوقية البيانات",
      "Key Data Discrepancies Identified": "التناقضات الرئيسية المحددة في البيانات",
      "Clear Filters": "مسح المرشحات",
      "Search Entity": "البحث في الجهة",
      "All Categories": "جميع الفئات",
      "All Entities": "جميع الجهات",
      "All Types": "جميع الأنواع",
      "All Donors": "جميع المانحين",
      "Donor": "المانح",
      "High Relief Commission": "الهيئة العليا للإغاثة",
      "Government Emergency Committee": "لجنة الطوارئ الحكومية",
      "South Council": "مجلس الجنوب",
      "hrc_description": "هيئة وطنية مسؤولة عن استقبال التبرعات والمساعدات من الجهات الدولية والإقليمية والمحلية، وتقديم الإغاثة للسكان المتضررين. تدير استقبال الإمدادات عبر الموانئ والمطارات وتنسق مع هياكل الطوارئ الحكومية لضمان التوزيع وفقاً للآليات الرسمية.",
      "Sources": "المصادر",
      "Filter Procurement Items": "تصفية عناصر المشتريات",
      "Medical Donations and Distribution Report": "تقرير التبرعات الطبية والتوزيع",
      "moph_description": "كيان عام رئيسي مسؤول عن توزيع المساعدات الطبية والأدوية، مرتبط مباشرة بالخدمات الصحية من خلال المستشفيات العامة ومراكز الرعاية الصحية الأولية.",
      "Total Packages": "إجمالي الرزم",
      "Medical Types": "الأنواع الطبية",
      "Search Items or Sources": "البحث في العناصر أو المصادر",
      "All Sources": "جميع المصادر",
      "Governorates": "المحافظات",
      "Filter Medical Donations": "تصفية التبرعات الطبية",
      "Search Medical Donations": "البحث في التبرعات الطبية",
      "Governorate": "المحافظة",
      "All Governorates": "جميع المحافظات",
      "No medical donations match your filters": "لا توجد تبرعات طبية تطابق المرشحات",
      "Village Aid Distribution Report": "تقرير توزيع المساعدات على القرى",
      "south_description": "مؤسسة عامة مكلفة بتقديم المساعدة في جنوب لبنان، وإدارة المخصصات المالية المخصصة، وتنفيذ مشاريع التنمية والخدمات التي تشمل توزيع المساعدات.",
      "Total Villages": "إجمالي القرى",
      "Item Types": "أنواع العناصر",
      "Filter Village Distributions": "تصفية توزيعات القرى",
      "Search Villages": "البحث في القرى",
      "Village": "القرية",
      "All Villages": "جميع القرى",
      "Item": "العنصر",
      "All Records": "جميع السجلات",
      "No villages match your filters": "لا توجد قرى تطابق المرشحات",
      "Distributed Items": "العناصر الموزعة",
      "Quantities": "الكميات",
      "analysis_warning_intro": "تشير التناقضات في البيانات المحددة في هذا التحليل إلى مشاكل منهجية في تتبع وتوزيع المساعدات. يشير حجم التناقضات (مئات الآلاف من الوحدات) إلى:",
      "analysis_issue_1": "فشل كبير في جمع البيانات وتسجيلها",
      "analysis_issue_2": "احتمال سوء استخدام الموارد",
      "analysis_issue_3": "انهيار كامل في التنسيق بين الوكالات",
      "analysis_confidence_text": "مستوى الثقة في البيانات الحالية",
      "LOW": "منخفض",
      "analysis_confidence_detail": "تم اكتشاف فشل متعدد في التحقق عبر جميع فئات المساعدات الرئيسية والدول المانحة",
      "Measurement Unit Inconsistencies": "تناقضات وحدات القياس",
      "Problem": "المشكلة",
      "measurement_problem_text": "تستخدم الوكالات المختلفة وحدات قياس مختلفة لنفس العناصر",
      "Example": "مثال",
      "measurement_example_text": "تسجل لجنة الطوارئ الحكومية التواريخ كـ 'صناديق' بينما تسجلها الهيئة العليا للإغاثة كـ 'علب'",
      "Impact": "التأثير",
      "measurement_impact_text": "يجعل التتبع والتحقق الدقيق مستحيلاً",
      "Receipt vs. Distribution Mismatches": "عدم تطابق الاستلام مقابل التوزيع",
      "Case Study": "دراسة حالة",
      "Kuwaiti Aid": "المساعدات الكويتية",
      "Higher Relief Authority Claims": "ادعاءات الهيئة العليا للإغاثة",
      "kuwait_received_text": "تم الاستلام: 42.3 طن (42,300 كيلوغرام = 42,300 وحدة)",
      "Distributed breakdown": "تفصيل التوزيع",
      "kuwait_blankets_text": "27,405 بطانية",
      "kuwait_food_text": "14,880 حصة غذائية",
      "kuwait_medical_text": "50,975 إمدادات طبية",
      "kuwait_total_text": "إجمالي الموزع: 93,206 وحدة",
      "kuwait_critical_issue": "قضية حرجة: التوزيع يتجاوز المستلم بأكثر من 50,000 وحدة",
      "Turkish Aid Discrepancies": "تناقضات المساعدات التركية",
      "Biscuits Transfer Issue": "مشكلة نقل البسكويت",
      "biscuits_hrc_text": "سجلت الهيئة العليا للإغاثة نقل 5,940 قطعة إلى لجنة الطوارئ",
      "biscuits_gec_text": "سجلت لجنة الطوارئ استلام 720 صندوق فقط",
      "biscuits_math_text": "استحالة رياضية: 5,940 ÷ 720 = 8.25 قطعة لكل صندوق (ربع قطع؟)",
      "Pasta Distribution": "توزيع المعكرونة",
      "pasta_hrc_text": "الهيئة العليا للإغاثة: تم نقل 10,000 قطعة",
      "pasta_gec_text": "لجنة الطوارئ: تم استلام 240 صندوق",
      "pasta_ratio_text": "النسبة: 10,000 ÷ 240 = 41.67 قطعة لكل صندوق",
      "HRC Transferred": "منقول من الهيئة العليا",
      "GEC Received": "مستلم من لجنة الطوارئ",
      "Ratio": "النسبة",
      "Issue": "المشكلة",
      "Summary Statistics Dashboard": "لوحة الإحصائيات الموجزة",
      "Total Aid Overview": "نظرة عامة على إجمالي المساعدات",
      "Total Received by All Agencies": "إجمالي المستلم من جميع الوكالات",
      "Total Distributed": "إجمالي الموزع",
      "Unaccounted Difference": "الفرق غير المحسوب",
      "units": "وحدة",
      "Aid by Month (Received)": "المساعدات حسب الشهر (المستلمة)",
      "Month": "الشهر",
      "Units Received": "الوحدات المستلمة",
      "Top Donor Countries/Entities": "أهم الدول/الكيانات المانحة",
      "Units Provided": "الوحدات المقدمة",
      "Aid Categories Distribution": "توزيع فئات المساعدات",
      "Category": "الفئة",
      "Units": "الوحدات",
      "Major Aid Distribution Anomalies by Country": "الشذوذ الرئيسي في توزيع المساعدات حسب البلد",
      "Country": "البلد",
      "Received": "المستلم",
      "Distributed": "الموزع",
      "Severity": "الخطورة",
      "Recommendations for System Improvement": "توصيات لتحسين النظام",
      "Immediate Actions Needed": "الإجراءات الفورية المطلوبة",
      "Standardize Measurement Units": "توحيد وحدات القياس",
      "standardize_units_text": "تنفيذ معايير قياس موحدة عبر جميع الوكالات",
      "Digital Integration": "التكامل الرقمي",
      "digital_integration_text": "استبدال تقارير PDF بأنظمة قواعد بيانات قابلة للبحث",
      "Real-time Tracking": "التتبع في الوقت الفعلي",
      "realtime_tracking_text": "إنشاء أنظمة إدارة المخزون المباشرة",
      "Geographic Mapping": "رسم الخرائط الجغرافية",
      "geographic_mapping_text": "تسجيل الموقع الإجباري لجميع التوزيعات",
      "Long-term Reforms": "الإصلاحات طويلة المدى",
      "Unified Command Structure": "هيكل القيادة الموحد",
      "unified_command_text": "هيئة تنسيق واحدة لجميع المساعدات الإنسانية",
      "Transparency Portal": "بوابة الشفافية",
      "transparency_portal_text": "لوحة معلومات عامة تظهر تدفقات المساعدات في الوقت الفعلي",
      "Independent Auditing": "التدقيق المستقل",
      "independent_auditing_text": "التحقق المنتظم من طرف ثالث لتوزيع المساعدات",
      "Beneficiary Registration": "تسجيل المستفيدين",
      "beneficiary_registration_text": "نظام شامل لتتبع متلقي المساعدات",
      "Critical Issues Identified": "القضايا الحرجة المحددة",
      "Data Quality Problems": "مشاكل جودة البيانات",
      "data_quality_problems_text": "وحدات قياس غير متسقة عبر الوكالات، طوابع زمنية مفقودة، بيانات جغرافية غير مكتملة، نقص في أنظمة تحديد المستفيدين",
      "Transparency Gaps": "فجوات الشفافية",
      "transparency_gaps_text": "71% من توزيعات الهيئة العليا للإغاثة مُعلمة كـ 'موقع غير معروف'، تحقق غير كافٍ من المانحين، مراجع متقاطعة مفقودة، تنسيقات بيانات PDF فقط",
      "Coordination Failures": "فشل التنسيق",
      "coordination_failures_text": "وكالات متعددة تسجل نفس المساعدة بشكل مختلف، لا يوجد نظام تتبع موحد، نقص في إدارة المخزون في الوقت الفعلي، ضعف التواصل بين الوكالات",
      
      // New detailed case translations
      "Major Cases of Aid Distribution Discrepancies": "الحالات الرئيسية لتناقضات توزيع المساعدات",
      "Case 1: Kuwait Aid - Unit Measurement Confusion": "الحالة الأولى: المساعدات الكويتية - الخلط في وحدات القياس",
      "Case 2: Turkey - Biscuits and Pasta Mathematics": "الحالة الثانية: تركيا - رياضيات البسكويت والمعكرونة",
      "Case 3: Turkey - Blankets and Mattresses Multiplication": "الحالة الثالثة: تركيا - تضاعف البطانيات والمراتب",
      "Case 4: UAE - Missing Sugar and Food": "الحالة الرابعة: الإمارات - السكر والطعام المفقود",
      "Case 5: Egypt - The Vanishing Blankets": "الحالة الخامسة: مصر - البطانيات المختفية",
      "Case 6: Congo - Multiplication Mystery": "الحالة السادسة: الكونغو - لغز التضاعف",
      "Case 7: Pakistan - The Bulk Disappearance": "الحالة السابعة: باكستان - الاختفاء الجماعي",
      "The Problem": "المشكلة",
      "Biscuits Discrepancy": "تناقض البسكويت",
      "Pasta Discrepancy": "تناقض المعكرونة",
      "Critical Issue": "قضية حرجة",
      "Critical Question": "سؤال حرج",
      "Items Received from UAE": "العناصر المستلمة من الإمارات",
      "Distribution Records (by GEC)": "سجلات التوزيع (من لجنة الطوارئ الحكومية)",
      "Missing/Extra": "مفقود/إضافي",
      "Received from Egypt": "مستلم من مصر",
      "Distributed (according to HRC records)": "موزع (وفقاً لسجلات الهيئة العليا للإغاثة)",
      "Missing Items": "العناصر المفقودة",
      "Data": "البيانات",
      "Received from Pakistan (Total: 125,749 pieces)": "مستلم من باكستان (المجموع: 125,749 قطعة)",
      "Distributed (by HRC)": "موزع (من الهيئة العليا للإغاثة)",
      "When traced to GEC records": "عند التتبع في سجلات لجنة الطوارئ الحكومية",
      "HRC Received": "مستلم من الهيئة العليا",
      "GEC Received": "مستلم من لجنة الطوارئ",
      "Overall System-Wide Discrepancies": "التناقضات الشاملة على مستوى النظام",
      "Aggregate Comparison": "المقارنة الإجمالية",
      "By Category - Massive Gaps": "حسب الفئة - فجوات هائلة",
      "Unaccounted": "غير محسوب",
      "Geographic Distribution Problems": "مشاكل التوزيع الجغرافي",
      "Unknown Location": "موقع غير معروف",
      "Known Distribution by Governorate": "التوزيع المعروف حسب المحافظة",
      "Governorate": "المحافظة",
      "Units Distributed": "الوحدات الموزعة",
      "Received from Turkey": "مستلم من تركيا",
      "Discrepancy": "التناقض",
      
      // Additional detailed translations
      "42.3 tons from Kuwait (recorded as 42,300 kg = 42,300 units)": "42.3 طن من الكويت (مسجل كـ 42,300 كيلوغرام = 42,300 وحدة)",
      "The 42.3 tons were broken down into:": "تم تقسيم الـ 42.3 طن إلى:",
      "27,405 blankets": "27,405 بطانية",
      "14,880 food rations": "14,880 حصة غذائية", 
      "50,975 medical supplies": "50,975 إمدادات طبية",
      "Total distributed: 93,206 units": "إجمالي الموزع: 93,206 وحدة",
      "How can 42,300 units received become 93,206 units distributed? This represents impossible unit conversion.": "كيف يمكن أن تصبح 42,300 وحدة مستلمة إلى 93,206 وحدة موزعة؟ هذا يمثل تحويل وحدات مستحيل.",
      "HRC (Higher Relief Authority) transferred:": "الهيئة العليا للإغاثة نقلت:",
      "5,940 pieces to GEC (Government Emergency Committee)": "5,940 قطعة إلى لجنة الطوارئ الحكومية",
      "GEC recorded receiving:": "لجنة الطوارئ الحكومية سجلت استلام:",
      "720 boxes": "720 صندوق",
      "Calculation:": "الحساب:",
      "5,940 ÷ 720 = 8.25 pieces per box": "5,940 ÷ 720 = 8.25 قطعة لكل صندوق",
      "Problem:": "المشكلة:",
      "How can a box contain 8.25 (eight and a quarter) pieces of biscuits?": "كيف يمكن أن يحتوي صندوق على 8.25 (ثمانية وربع) قطعة من البسكويت؟",
      "HRC transferred:": "الهيئة العليا للإغاثة نقلت:",
      "10,000 pieces to GEC": "10,000 قطعة إلى لجنة الطوارئ الحكومية",
      "240 boxes": "240 صندوق",
      "10,000 ÷ 240 = 41.67 pieces per box": "10,000 ÷ 240 = 41.67 قطعة لكل صندوق",
      "Mathematically illogical ratio suggests either:": "النسبة غير المنطقية رياضياً تشير إلى:",
      "10 boxes disappeared in transit, OR": "10 صناديق اختفت في النقل، أو",
      "Recording error (should be 250 boxes = 40 pieces/box)": "خطأ في التسجيل (يجب أن يكون 250 صندوق = 40 قطعة/صندوق)",
      "5,940 pieces": "5,940 قطعة",
      "8.25 pieces/box": "8.25 قطعة/صندوق",
      "Quarter pieces?": "ربع قطع؟",
      "10,000 pieces": "10,000 قطعة",
      "41.67 pieces/box": "41.67 قطعة/صندوق",
      "Mathematical impossibility": "استحالة رياضية",
      "Blankets": "بطانيات",
      "Mattresses": "مراتب",
      "139,000": "139,000",
      "167,000+": "167,000+",
      "+28,000 blankets appeared": "+28,000 بطانية ظهرت",
      "2,000": "2,000",
      "57,000+": "57,000+",
      "+55,000 mattresses appeared": "+55,000 مرتبة ظهرت",
      "Where did the additional 28,000 blankets and 55,000 mattresses come from? Were there unreported donations?": "من أين أتت الـ 28,000 بطانية و55,000 مرتبة الإضافية؟ هل كانت هناك تبرعات غير مبلغ عنها؟",
      "17,280 milk cans": "17,280 علبة حليب",
      "1,759 bags of sugar (98 tons)": "1,759 كيس سكر (98 طن)",
      "805 pieces of peas (6 tons)": "805 قطعة بازلاء (6 أطنان)",
      "200 pieces of lentils (6 tons)": "200 قطعة عدس (6 أطنان)",
      "Milk": "حليب",
      "17,280 cans": "17,280 علبة",
      "360 boxes (17,280 cans if 48/box)": "360 صندوق (17,280 علبة إذا كان 48/صندوق)",
      "✓ Matches": "✓ متطابق",
      "Sugar": "سكر",
      "1,759 bags (98 tons)": "1,759 كيس (98 طن)",
      "92 tons": "92 طن",
      "-6 tons missing": "-6 أطنان مفقودة",
      "Peas": "بازلاء",
      "805 pieces (6 tons)": "805 قطعة (6 أطنان)",
      "1,185 kg (1.185 tons)": "1,185 كيلوغرام (1.185 طن)",
      "-4.8 tons missing": "-4.8 طن مفقود",
      "Lentils": "عدس",
      "200 pieces (6 tons)": "200 قطعة (6 أطنان)",
      "454 kg (7.454 tons)": "454 كيلوغرام (7.454 طن)",
      "+1 ton extra": "+1 طن إضافي",
      "6 tons of sugar vanished, while 1 ton of lentils appeared from nowhere.": "6 أطنان من السكر اختفت، بينما ظهر طن واحد من العدس من العدم.",
      
      // Cases 5-7 translations
      "1,864 food rations": "1,864 حصة غذائية",
      "4,000 blankets": "4,000 بطانية", 
      "26 tents": "26 خيمة",
      "21,072 kg food materials": "21,072 كيلوغرام مواد غذائية",
      "1,887 food rations": "1,887 حصة غذائية",
      "2,075 blankets": "2,075 بطانية",
      "24 tents": "24 خيمة",
      "No food materials recorded": "لا توجد مواد غذائية مسجلة",
      "~2,000 blankets missing + 21 tons food materials unaccounted": "~2,000 بطانية مفقودة + 21 طن مواد غذائية غير محسوبة",
      "Congo": "الكونغو",
      "125,749 pieces total": "125,749 قطعة إجمالي",
      "Only 23,674 pieces distributed": "23,674 قطعة فقط موزعة",
      "102,075 pieces missing": "102,075 قطعة مفقودة",
      "Where did 81% of Pakistani aid disappear?": "أين اختفت 81% من المساعدات الباكستانية؟",
      "Total Received": "إجمالي المستلم",
      "Total Distributed by All Agencies": "إجمالي الموزع من جميع الوكالات",
      "2,806,744 units": "2,806,744 وحدة",
      "2,399,061 units": "2,399,061 وحدة",
      "407,683 units unaccounted": "407,683 وحدة غير محسوبة",
      "Food": "غذاء",
      "726,306 received": "726,306 مستلم",
      "580,234 distributed": "580,234 موزع",
      "146,072 unaccounted": "146,072 غير محسوب",
      "Medical/Pharmaceutical": "طبي/صيدلاني",
      "803,180 received": "803,180 مستلم",
      "721,445 distributed": "721,445 موزع",
      "81,735 unaccounted": "81,735 غير محسوب",
      "Shelter": "مأوى",
      "564,809 received": "564,809 مستلم",
      "498,123 distributed": "498,123 موزع",
      "66,686 unaccounted": "66,686 غير محسوب",
      "71% of distributions": "71% من التوزيعات",
      "Beirut": "بيروت",
      "Mount Lebanon": "جبل لبنان",
      "South Lebanon": "جنوب لبنان",
      "Bekaa": "البقاع",
      "North Lebanon": "شمال لبنان",
      "Nabatieh": "النبطية",
      "185,432 (highest)": "185,432 (الأعلى)",
      "156,789": "156,789",
      "98,234": "98,234",
      "87,456": "87,456",
      "72,891": "72,891",
      "50 (lowest)": "50 (الأدنى)",
      "~2,000 blankets (half the shipment)": "~2,000 بطانية (نصف الشحنة)",
      "21 tons of food materials (completely unaccounted for)": "21 طن من المواد الغذائية (غير محسوبة بالكامل)",
      "1,050 pieces of used clothing": "1,050 قطعة ملابس مستعملة",
      "8,000 blankets": "8,000 بطانية",
      "12,750 pieces of clothing": "12,750 قطعة ملابس",
      "How does 1,050 pieces become 20,750 items?": "كيف تصبح 1,050 قطعة إلى 20,750 عنصر؟",
      "5,950 blankets": "5,950 بطانية",
      "4,000 winter clothes": "4,000 ملابس شتوية",
      "7,124 milk bottles": "7,124 زجاجة حليب",
      "1,845 hygiene bags": "1,845 حقيبة نظافة",
      "14,635 relief materials": "14,635 مواد إغاثة",
      "50,000 medicine pieces": "50,000 قطعة دواء",
      "2,700 canned food boxes": "2,700 صندوق طعام معلب",
      "2,000 pieces of clothing": "2,000 قطعة ملابس",
      "22,200 ready-to-eat meals": "22,200 وجبة جاهزة للأكل",
      "10,295 tents": "10,295 خيمة",
      "Only 25 blankets": "25 بطانية فقط",
      "684 tents": "684 خيمة",
      "Everything else: UNACCOUNTED FOR": "كل شيء آخر: غير محسوب",
      "Rice": "أرز",
      "Not specified": "غير محدد",
      "168 bags (10 kg each)": "168 كيس (10 كيلوغرام لكل منها)",
      "Unknown origin": "مصدر غير معروف",
      "5,950": "5,950",
      "1,035": "1,035",
      "Where are 4,915?": "أين الـ 4,915؟",
      "Shelter bags": "أكياس مأوى",
      "Not in HRC list": "ليس في قائمة الهيئة العليا للإغاثة",
      "2,066": "2,066",
      "New item appeared": "عنصر جديد ظهر",
      "Tents": "خيام",
      "10,295": "10,295",
      "775": "775",
      "Missing 9,520 tents": "9,520 خيمة مفقودة",
      "Packaged food": "طعام معبأ",
      "2,700 boxes": "2,700 صندوق",
      "2,250 boxes": "2,250 صندوق",
      "Missing 450 boxes": "450 صندوق مفقود",
      "Total Received": "إجمالي المستلم",
      "2,806,744": "2,806,744",
      "units (All Agencies)": "وحدة (جميع الوكالات)",
      "Total Distributed": "إجمالي الموزع",
      "2,366,729": "2,366,729",
      "units": "وحدة",
      "Gap": "الفجوة",
      "470,015": "470,015",
      "units (16.74%)": "وحدة (16.74%)",
      "Food": "غذاء",
      "726,306": "726,306",
      "335,922 (46.2%)": "335,922 (46.2%)",
      "390,384 units": "390,384 وحدة",
      "Medicine": "دواء",
      "803,180": "803,180",
      "709,358": "709,358",
      "93,822 units": "93,822 وحدة",
      "Shelter": "مأوى",
      "564,809": "564,809",
      "564,455": "564,455",
      "354 units": "354 وحدة",
      "Hygiene": "نظافة",
      "304,766": "304,766",
      "391,769": "391,769",
      "+86,003 (more distributed!)": "+86,003 (موزع أكثر!)",
      "Clothing": "ملابس",
      "22,601": "22,601",
      "52,841": "52,841",
      "+30,240 (more distributed!)": "+30,240 (موزع أكثر!)",
      "1,753,847 units (74% of total) distributed to \"Unknown Location\"": "1,753,847 وحدة (74% من الإجمالي) موزعة إلى \"موقع غير معروف\"",
      "281,057": "281,057",
      "226,158": "226,158",
      "54,145": "54,145",
      "Akkar": "عكار",
      "10,626": "10,626",
      "18,171": "18,171",
      "Baalbek-Hermel": "بعلبك-الهرمل",
      "16,875": "16,875",
      
      // Months
      "September 2024": "سبتمبر 2024",
      "October 2024": "أكتوبر 2024", 
      "November 2024": "نوفمبر 2024",
      "December 2024": "ديسمبر 2024",
      "Undetermined": "غير محدد",
      
      // Countries
      "UAE": "الإمارات العربية المتحدة",
      "Saudi Arabia": "المملكة العربية السعودية",
      "Turkey": "تركيا",
      "Direct Purchases": "مشتريات مباشرة",
      "Pakistan": "باكستان",
      "Kuwait": "الكويت",
      "Egypt": "مصر",
      
      // Categories
      "Medical/Pharmaceutical": "طبي/صيدلاني",
      "Food": "غذاء",
      "Shelter": "مأوى",
      "Health/Hygiene": "صحة/نظافة",
      
      // Severity levels
      "Critical": "حرج",
      "High": "عالي",
      "Medium": "متوسط",
      
      // Turkish discrepancy items
      "Biscuits": "بسكويت",
      "Pasta": "معكرونة",
      "5,940 pieces": "5,940 قطعة",
      "720 boxes": "720 صندوق",
      "8.25 pieces/box": "8.25 قطعة/صندوق",
      "Quarter pieces?": "ربع قطع؟",
      "10,000 pieces": "10,000 قطعة",
      "240 boxes": "240 صندوق",
      "41.67 pieces/box": "41.67 قطعة/صندوق",
      "Mathematical impossibility": "استحالة رياضية",
      
      // Discrepancy case data
      "42.3 tons (42,300 units)": "42.3 طن (42,300 وحدة)",
      "93,206 units": "93,206 وحدة",
      "Distribution exceeds receipts by over 50,000 units": "التوزيع يتجاوز المستلم بأكثر من 50,000 وحدة",
      "139,000 blankets, 2,000 mattresses": "139,000 بطانية، 2,000 مرتبة",
      "167,000+ blankets, 57,000+ mattresses": "167,000+ بطانية، 57,000+ مرتبة",
      "Distribution significantly exceeds receipts": "التوزيع يتجاوز المستلم بشكل كبير",
      "Various items": "عناصر متنوعة",
      "Missing 17,280 milk cans, 6 tons food materials": "مفقود 17,280 علبة حليب، 6 أطنان مواد غذائية",
      "Significant items unaccounted for": "عناصر مهمة غير محسوبة",
      "1,864 food rations, 4,000 blankets, 21 tons food": "1,864 حصة غذائية، 4,000 بطانية، 21 طن طعام",
      "1,887 food rations, 2,075 blankets": "1,887 حصة غذائية، 2,075 بطانية",
      "~2,000 blankets and 21 tons food missing": "~2,000 بطانية و21 طن طعام مفقود",
      
      // AgencyStats translations
      "Total Aid Received": "إجمالي المساعدات المستلمة",
      "Total Distributed": "إجمالي الموزع", 
      "Distribution Rate": "معدل التوزيع",
      "Undistributed": "غير موزع",
      "units": "وحدة",
      "efficiency": "كفاءة",
      "Share of Total National Aid": "حصة من إجمالي المساعدات الوطنية",
      "of all aid received by Lebanon": "من جميع المساعدات المستلمة في لبنان",
      "Peak Activity Period": "فترة الذروة النشاط",
      "Highest Receipt Month": "أعلى شهر استلام",
      "Primary Function": "الوظيفة الأساسية",
      "Source": "المصدر",
      "Service Areas": "مناطق الخدمة",
      "Aid by Measurement Units": "المساعدات حسب وحدات القياس",
      "Unit Type": "نوع الوحدة",
      "Quantity": "الكمية",
      "Weight (Tons)": "الوزن (أطنان)",
      "Top Donor Countries": "أهم الدول المانحة",
      "Units Received": "الوحدات المستلمة",
      "Units Distributed": "الوحدات الموزعة",
      "Distribution Rate": "معدل التوزيع",
      "Weight (Tons)": "الوزن (أطنان)",
      "Primary Focus Areas": "مناطق التركيز الأساسية",
      "Aid Categories": "فئات المساعدات",
      "Focus Area": "منطقة التركيز",
      "Percentage": "النسبة المئوية",
      "Geographic Distribution Issues": "مشاكل التوزيع الجغرافي",
      "Identified Locations": "المواقع المحددة",
      "Only 29% of distributions have clear geographic data": "29% فقط من التوزيعات لديها بيانات جغرافية واضحة",
      "Village Distribution Network": "شبكة توزيع القرى",
      "International Support Sources": "مصادر الدعم الدولي",
      "Organization": "المنظمة",
      "Support Type": "نوع الدعم",
      "Monthly Financial Distribution": "التوزيع المالي الشهري",
      "Amount (Million USD)": "المبلغ (مليون دولار أمريكي)",
      
      // Unit types
      "Pieces": "قطع",
      "Kilograms": "كيلوغرام", 
      "Medicine Boxes (EA)": "صناديق دواء (وحدة)",
      "Rations": "حصص",
      "Boxes": "صناديق",
      "Bags": "أكياس",
      "Packages": "رزم",
      "Pills": "حبوب",
      "Sets": "مجموعات",
      "Cans": "علب",
      "Containers": "حاويات",
      "Wooden Boards": "ألواح خشبية",
      
      // Focus areas and categories
      "Food Aid": "مساعدات غذائية",
      "Shelter Materials": "مواد المأوى",
      "Other Categories": "فئات أخرى",
      "Heavy Winter Clothing": "ملابس شتوية ثقيلة",
      "Blankets": "بطانيات",
      "Basic Necessities": "الضروريات الأساسية",
      
      // Beneficiary types
      "Municipalities": "البلديات",
      "Displaced Families": "العائلات النازحة",
      "Non-governmental Organizations": "المنظمات غير الحكومية",
      "Governorates": "المحافظات",
      "Religious Institutions": "المؤسسات الدينية",
      "Official Schools": "المدارس الرسمية",
      "Security Forces": "القوى الأمنية",
      "Security/Military Institutions": "المؤسسات الأمنية/العسكرية",
      "Lebanese Red Cross": "الصليب الأحمر اللبناني",
      "Packaging/Processing": "التعبئة/المعالجة",
      "Small amounts": "كميات صغيرة",
      "Some units": "بعض الوحدات",
      "Various": "متنوعة",
      
      // Countries
      "Qatar": "قطر",
      "Canada": "كندا",
      "China": "الصين",
      "UK": "المملكة المتحدة",
      "Spain": "إسبانيا",
      
      // Village distribution items
      "Villages Served": "القرى المخدومة",
      "Food Rations Distributed": "الحصص الغذائية الموزعة",
      "Mattresses": "مراتب",
      "Blankets/Covers": "بطانيات/أغطية",
      "Pillows": "وسائد",
      "Milk Containers": "حاويات الحليب",
      "Baby Diapers": "حفاضات الأطفال",
      
      // Months
      "October": "أكتوبر",
      "November": "نوفمبر",
      "December": "ديسمبر",
      
      // MOPH specific
      "from Higher Relief Authority": "من الهيئة العليا للإغاثة",
      "Medical and pharmaceutical aid distribution": "توزيع المساعدات الطبية والصيدلانية",
      "Chronic diseases": "الأمراض المزمنة",
      "Hospital services": "خدمات المستشفيات",
      "Primary health centers": "مراكز الرعاية الصحية الأولية",
      "World Health Organization": "منظمة الصحة العالمية",
      "Medical supplies": "الإمدادات الطبية",
      "UNICEF": "اليونيسف",
      "Child health materials": "مواد صحة الطفل",
      "UN Population Fund": "صندوق الأمم المتحدة للسكان",
      "Reproductive health supplies": "إمدادات الصحة الإنجابية",
      "Pharmaceutical donations": "التبرعات الصيدلانية",
      "Medical equipment": "المعدات الطبية",
      "European Union": "الاتحاد الأوروبي",
      "Chronic disease medications": "أدوية الأمراض المزمنة",
      "Diesel Generators": "مولدات الديزل",
      "20,000+ liters for hospitals": "20,000+ لتر للمستشفيات",
      "Oxygen Equipment": "معدات الأكسجين",
      "Various quantities": "كميات متنوعة",
      "Surgical Supplies": "الإمدادات الجراحية",
      "Large quantities distributed": "كميات كبيرة موزعة",
      "Anesthesia Equipment": "معدات التخدير",
      "Hospital distribution": "توزيع المستشفيات",
      
      // Geographic and coordination
      "Unknown Locations": "مواقع غير معروفة",
      "Primary Function: Direct distribution to governorates and security institutions": "الوظيفة الأساسية: التوزيع المباشر على المحافظات والمؤسسات الأمنية",
      "Focus Area: South Lebanon villages with direct village-to-village delivery": "منطقة التركيز: قرى جنوب لبنان مع التسليم المباشر من قرية إلى قرية",
      "*Data inconsistency": "*تناقض في البيانات",
      
      // Key Terms & FAQs Arabic
      "Key Terms & FAQs": "المصطلحات الأساسية والأسئلة الشائعة",
      "FAQ": "الأسئلة الشائعة",
      
      // Gherbal Initiative Branding Arabic
      "Powered by Gherbal Initiative": "بدعم من مبادرة غربال",
      "Transparent Aid Tracking & Data Verification": "تتبع المساعدات الشفاف والتحقق من البيانات",
      
      // Information Requests Arabic
      "Register of Information Requests": "سجل طلبات المعلومات",
      "Official Responses from Administration": "الردود الرسمية من الإدارة",
      "View Documents": "عرض الوثائق",
      "faq_subtitle": "فهم مصطلحات المساعدات الإنسانية والإجابة على الأسئلة الشائعة حول عمليات جمع البيانات والتحقق منها.",
      "About This Information": "حول هذه المعلومات",
      
      // Chatbot translations Arabic
      "chatbot": {
        "title": "مساعد غربال",
        "welcome": "مرحباً! أنا مساعد غربال الذكي المحسن بالذكاء الاصطناعي. يمكنني مساعدتك في فهم تقرير توزيع المساعدات الإنسانية في لبنان خلال العدوان الإسرائيلي 2024. اسألني عن كميات المساعدات، الدول المانحة، مشاكل التوزيع، أو مخاوف الشفافية.",
        "placeholder": "اسألني عن تقرير المساعدات...",
        "suggestedQuestions": "أسئلة مقترحة:",
        "questions": {
          "totalAid": "ما هو إجمالي كمية المساعدات المستلمة؟",
          "topDonors": "ما هي الدول الأكثر تبرعاً؟",
          "aidCategories": "ما هي أنواع المساعدات التي تم توزيعها؟",
          "distributionIssues": "ما هي المشاكل التي تم العثور عليها في التوزيع؟",
          "transparency": "ما هي قضايا الشفافية التي تم تحديدها؟"
        }
      },
      "faq_overview_text": "تقدم هذه الصفحة تعريفات للمصطلحات الأساسية المستخدمة في متتبع المساعدات اللبنانية وتجيب على الأسئلة الشائعة حول عمليات جمع البيانات والتحقق منها وإجراءات الشفافية.",
      
      // Key Terms Arabic
      "Key Terms and Definitions": "المصطلحات والتعريفات الأساسية",
      "key_terms_intro": "المصطلحات الأساسية المستخدمة في تتبع وتوزيع المساعدات الإنسانية في لبنان.",
      
      "In-Kind Aid": "المساعدات العينية",
      "in_kind_aid_definition": "المساعدة المادية المقدمة في شكل سلع وليس نقداً. وتشمل عناصر مثل الطعام والدواء والبطانيات والخيام ومجموعات النظافة والإمدادات الطبية.",
      
      "Receiving Entity": "الجهة المستلمة",
      "receiving_entity_definition": "الهيئة الحكومية الرسمية أو المنظمة التي تقبل المساعدات الإنسانية نيابة عن الدولة اللبنانية، مثل الهيئة العليا للإغاثة أو لجنة الطوارئ الحكومية أو مجلس الجنوب.",
      
      "Distributing Entity": "الجهة الموزعة",
      "distributing_entity_definition": "المنظمة أو المؤسسة المسؤولة عن توصيل المساعدات إلى المستفيدين النهائيين، بما في ذلك البلديات والمنظمات غير الحكومية والصليب الأحمر اللبناني أو الوزارات الحكومية.",
      
      "Aid Categories": "فئات المساعدات",
      "aid_categories_definition": "الطب: الأدوية والإمدادات الطبية والمعدات الصحية\nالطعام: الطرود الغذائية والوجبات الجاهزة والسلع الأساسية\nالمأوى: الخيام والبطانيات والمراتب ومواد التدفئة\nالنظافة: مجموعات الصرف الصحي ومواد التنظيف ومنتجات العناية الشخصية\nالمساعدات المختلطة: الحزم التي تجمع فئات متعددة",
      
      "Unit of Measurement Discrepancy": "تناقض وحدة القياس",
      "unit_discrepancy_definition": "عندما تسجل جهات مختلفة نفس المساعدة باستخدام وحدات مختلفة (مثل تسجيل إحداها \"صناديق\" بينما تسجل أخرى \"قطع\")، مما يجعل التتبع الدقيق صعباً.",
      
      "Displaced Persons": "النازحون",
      "displaced_persons_definition": "الأفراد المجبرون على ترك منازلهم بسبب العدوان العسكري، والذين يبحثون عن مأوى مؤقت في مناطق أكثر أماناً داخل لبنان.",
      
      // FAQs Arabic
      "Frequently Asked Questions": "الأسئلة الشائعة",
      "faq_intro": "أسئلة شائعة حول عمليات جمع البيانات وإجراءات التحقق وتدابير الشفافية.",
      
      "How does Gherbal verify data?": "كيف تتحقق مبادرة الغربال من البيانات؟",
      "data_verification_answer": "تجمع مبادرة الغربال البيانات من مصادر متعددة:\n\n• الطلبات الرسمية: طلبات المعلومات الرسمية المقدمة للجهات الحكومية بموجب قانون الوصول إلى المعلومات 28/2017\n• السجلات المنشورة: المعلومات المنشورة على المواقع والمنصات الحكومية الرسمية\n• الإعلام الرسمي: البيانات والأرقام المنشورة عبر وكالة الأنباء الوطنية والقنوات الرسمية\n• المراجع المتقاطعة: مقارنة البيانات عبر مصادر متعددة لتحديد التناقضات\n\nيتم حفظ جميع الوثائق، بما في ذلك الردود الرسمية والمراسلات، ويمكن تقديمها عند الطلب.",
      
      "Why is some data missing or incomplete?": "لماذا بعض البيانات مفقودة أو غير مكتملة؟",
      "missing_data_answer": "عدة عوامل تساهم في فجوات البيانات:\n\n• عدم الاستجابة: بعض الجهات الحكومية لم تستجب لطلبات المعلومات رغم الالتزامات القانونية\n• المعلومات الجزئية: بعض الجهات قدمت مراجع عامة للمواقع بدلاً من مجموعات بيانات مفصلة\n• مشاكل التنسيق: البيانات المنشورة بصيغة PDF أو بدون حقول منظمة تحد من التحليل\n• التسجيل غير المتسق: وحدات قياس وأنظمة تصنيف مختلفة عبر الجهات\n• العمليات الجارية: بعض المساعدات تم تمييزها كـ \"في التخزين\" بدون جداول زمنية للتوزيع",
      
      "Why is data missing for region X?": "لماذا البيانات مفقودة للمنطقة س؟",
      "regional_gaps_answer": "فجوات البيانات الجغرافية تحدث لعدة أسباب:\n\n• ممارسات التسجيل: أكثر من 70% من المساعدات الموزعة من قبل الهيئة العليا للإغاثة سُجلت كـ \"موقع غير معروف\"\n• أنماط النزوح: المناطق التي تشهد صراعاً نشطاً شهدت نزوح السكان، مما قلل من التوزيع المحلي\n• التركز في المناطق المضيفة: المساعدات تركزت في المناطق التي تستقبل النازحين (بيروت، جبل لبنان) بدلاً من مناطق الصراع\n• التوثيق غير المكتمل: بعض الجهات لم تحدد مواقع التوزيع في سجلاتها",
      
      "How accurate is this data?": "ما مدى دقة هذه البيانات؟",
      "data_accuracy_answer": "البيانات تعكس ما تم تسجيله والكشف عنه رسمياً من قبل الجهات الحكومية. مبادرة الغربال توثق:\n\n• ما تلقيناه: الردود الرسمية والبيانات الحكومية المنشورة\n• التناقضات المعروفة: التناقضات المحددة بين الجهات\n• قيود البيانات: الحقول المفقودة والقياسات غير الواضحة والفجوات\n\nهذا جهد توثيقي، وليس عداً نهائياً. قد تختلف أحجام المساعدة الفعلية عن الأرقام المسجلة.",
      
      "Is this data updated in real-time?": "هل يتم تحديث هذه البيانات في الوقت الفعلي؟",
      "real_time_updates_answer": "لا. يغطي هذا التقرير الفترة من سبتمبر 2024 حتى يناير 2025. التحديثات تعتمد على:\n\n• الكشوفات الرسمية الجديدة\n• الردود على طلبات المعلومات المعلقة\n• توفر الموارد لمواصلة المراقبة",
      
      "Who can use this data?": "من يمكنه استخدام هذه البيانات؟",
      "data_usage_answer": "هذه البيانات متاحة للجمهور لـ:\n\n• الباحثين والأكاديميين\n• الصحفيين والمنظمات الإعلامية\n• منظمات المجتمع المدني\n• المانحين الدوليين والوكالات الإنسانية\n• أي مواطن يسعى للشفافية في توزيع المساعدات\n\nالإشارة إلى مبادرة الغربال مقدرة ولكنها غير مطلوبة.",
      
      "Why focus on government-managed aid?": "لماذا التركيز على المساعدات المدارة حكومياً؟",
      "government_focus_answer": "الدولة اللبنانية تلقت مساعدات دولية كبيرة عبر القنوات الرسمية. تتبع المساعدات المدارة حكومياً أمر أساسي لـ:\n\n• المساءلة العامة\n• تقييم عدالة التوزيع\n• تقييم فعالية التنسيق\n• إعلام تخطيط الاستجابة للطوارئ المستقبلية\n\nهذا لا ينتقص من العمل المهم للمنظمات غير الحكومية والمنظمات الدولية العاملة بشكل مستقل.",
      
      // Additional Information Section Arabic
      "Data Sources and Methodology": "مصادر البيانات والمنهجية",
      "Official Sources": "المصادر الرسمية",
      "official_sources_text": "جميع البيانات تأتي من ردود حكومية رسمية على طلبات الوصول للمعلومات، وتقارير حكومية منشورة، وبيانات رسمية موثقة.",
      
      "Transparency Commitment": "التزام الشفافية",
      "transparency_commitment_text": "نحتفظ بتوثيق كامل لجميع المصادر والمراسلات وعمليات جمع البيانات. جميع المواد متاحة للمراجعة العامة.",
      
      "Contact Information": "معلومات الاتصال",
      "contact_information_text": "للأسئلة حول المنهجية أو مصادر البيانات أو لطلب وثائق إضافية، يرجى زيارة elgherbal.org أو الاتصال بنا عبر القنوات الرسمية."
    }
  }
};

i18n
//   .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
